angular.module('app')
.config(function($stateProvider) {
  $stateProvider
    .state('projects',{
      url: '/projects',
      templateUrl: '../views/projects.html'
    });
});
